import { ReactElement } from 'react';

import { vpaSettingsConstants } from '../../_constants/settingsConstants';

import { VerticalSettingsForm } from '../layout/VerticalSettingsForm';
import { SettingsInfoCallout } from '../SettingsInfoCallout';

type PredictiveScalingSettingsContainerProps = {
  predictiveScalingField: ReactElement;
};

const INFO_BOX_TEXT =
  'Activates automatically when workloads become predictable and reverts to standard vertical scaling when they become unpredictable.';

export const PredictiveScalingSettingsContainer = ({
  predictiveScalingField,
}: PredictiveScalingSettingsContainerProps) => {
  const { title, description } = vpaSettingsConstants.predictiveScaling;

  return (
    <VerticalSettingsForm title={title} description={description}>
      {predictiveScalingField}

      <SettingsInfoCallout variant="neutral">
        {INFO_BOX_TEXT}
      </SettingsInfoCallout>
    </VerticalSettingsForm>
  );
};
